package com.rylcart.cp.ui.screens

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.rylcart.cp.ui.api.ApiException
import com.rylcart.cp.ui.api.Tenant
import com.rylcart.cp.ui.components.PrimaryButton
import com.rylcart.cp.ui.components.SecondaryButton
import com.rylcart.cp.ui.components.StatusBadge
import com.rylcart.cp.ui.state.LocalApp
import com.rylcart.cp.ui.state.Route
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Table
import org.jetbrains.compose.web.dom.Tbody
import org.jetbrains.compose.web.dom.Td
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Th
import org.jetbrains.compose.web.dom.Thead
import org.jetbrains.compose.web.dom.Tr
import org.jetbrains.compose.web.dom.Code

@Composable
fun TenantsScreen() {
    val app = LocalApp.current
    val scope = rememberCoroutineScope()
    var tenants by remember { mutableStateOf<List<Tenant>?>(null) }
    var refreshKey by remember { mutableStateOf(0) }

    LaunchedEffect(refreshKey) {
        runCatching { app.api.tenants() }
            .onSuccess { tenants = it }
            .onFailure { app.showError((it as? ApiException)?.message ?: "failed to load tenants") }
    }

    // Light polling so users see provisioning → active transitions live.
    LaunchedEffect(Unit) {
        while (true) {
            kotlinx.coroutines.delay(5000)
            runCatching { app.api.tenants() }.onSuccess { tenants = it }
        }
    }

    Div(attrs = { classes("row", "between"); style { property("margin-bottom", "20px") } }) {
        H2 { Text("Tenants") }
        PrimaryButton("+ New tenant") { app.navigate(Route.NewTenant) }
    }

    val list = tenants
    when {
        list == null -> Div(attrs = { classes("empty") }) { Text("Loading…") }
        list.isEmpty() -> Div(attrs = { classes("card", "empty") }) {
            Text("No tenants yet. ")
            A(href = "#/tenants/new") { Text("Spin up your first store →") }
        }
        else -> Div(attrs = { classes("card"); style { property("padding", "0") } }) {
            Table {
                Thead {
                    Tr { Th { Text("Name") }; Th { Text("Host") }; Th { Text("Status") }; Th { Text("Plan") }; Th { Text("Created") }; Th {} }
                }
                Tbody {
                    list.forEach { t ->
                        Tr {
                            Td { Text(t.name); Div(attrs = { classes("muted"); style { property("font-size", "12px") } }) { Code { Text(t.slug) } } }
                            Td { A(href = "https://${t.host}", attrs = { attr("target", "_blank"); attr("rel", "noopener") }) { Text(t.host) } }
                            Td { StatusBadge(t.status); t.lastError?.let { Div(attrs = { classes("muted"); style { property("font-size", "11px"); property("margin-top", "4px") } }) { Text(it) } } }
                            Td { Text(t.plan) }
                            Td(attrs = { classes("muted") }) { Text(t.createdAt.substringBefore("T")) }
                            Td { SecondaryButton("Open") { app.navigate(Route.TenantDetail(t.id)) } }
                        }
                    }
                }
            }
        }
    }
}
